<template>
    <div class="checkout-delivery-ukraine">
        <CheckoutDeliveryCities
            @changeCity="changeCity"
            :result="getCurrentCity"
            class="width-limiter"
        />
        <div
            v-for="item in items"
            :key="item.ID"
            class="checkout-delivery-ukraine__block"
            :class="{ 'checkout-delivery-ukraine__block_disabled': item.DISABLED }"
        >
            <div class="checkout-delivery-ukraine__header width-limiter">
                <DefRadio
                    :name="delivery.inputName"
                    :checked="item.CHECKED === 'Y'"
                    @change="changeData(delivery.inputName, item.ID)"
                >
                    {{ item.NAME }}
                </DefRadio>
                <span
                    v-if="item?.obPrice?.price === 0"
                    class="checkout-delivery-ukraine__free"
                >
                    {{ delivery?.messages?.freeDelivery }}
                </span>
                <span
                    v-else
                    class="checkout-delivery-ukraine__price"
                >
                    {{ item.obPrice.printPrice }}
                </span>
            </div>
            <div v-if="item.CHECKED === 'Y'">
                <div class="checkout-delivery-ukraine__footer">
                    <!-- delivery shops-->
                    <CheckoutDeliveryShops
                        v-if="item.ID === '2'"
                        :result="item"
                        :currentCity="getCurrentCity"
                        class="width-limiter"
                    />
                    <!-- delivery novaposhta courier and IPOST  -->
                    <CheckoutDeliveryFields
                        v-else-if="item.ID === '3' || item.ID === '10'"
                        :result="item"
                    />
                    <!-- delivery nowa poshta-->
                    <CheckoutDeliveryWarehouses
                        v-else-if="item.ID === '5'"
                        :result="item"
                        :currentCity="getCurrentCity"
                        class="width-limiter"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CheckoutDeliveryCities from "./CheckoutDeliveryCities";
import DefRadio from "../../../def/DefRadio/DefRadio";
import CheckoutDeliveryShops from "./CheckoutDeliveryShops";
import CheckoutDeliveryFields from "./CheckoutDeliveryFields";
import CheckoutDeliveryWarehouses from "./CheckoutDeliveryWarehouses";

export default {
    name: 'CheckoutDeliveryUkraine',
    components: {
        CheckoutDeliveryCities,
        DefRadio,
        CheckoutDeliveryShops,
        CheckoutDeliveryFields,
        CheckoutDeliveryWarehouses,
    },
    data() {
        return {
            currentCity: null,
        }
    },
    computed: {
        ...mapState({
            delivery: ({ checkout }) => checkout.data.vue?.delivery,
            items: ({ checkout }) => checkout.data.vue?.delivery?.items,
            userCity: ({ cities }) => cities.data.userCity,
            deliveryProps: ({ checkout }) => checkout.data.vue.delivery.props,
            inputStoreID: ({ checkout }) => checkout?.data?.vue?.delivery?.inputStoreID
        }),
        getCurrentCity() {
            return this.currentCity ?? this.userCity;
        },
        getCityKey() {
            return Object.values(this.deliveryProps)?.find(el => el.CODE === 'CITY')?.inputName;
        },
        getActiveDelivery() {
            return Object.values(this.delivery.items).find(el => el.CHECKED === 'Y')
        },

        getWarehousesInputName() {
            return Object.values(this.deliveryProps)?.find(el => el.CODE === 'NP_DEPARTMENT')?.inputName;
        }
    },
    methods: {
        ...mapMutations({
            setRequestData: 'checkout/setRequestData'
        }),
        ...mapActions({
            setAjax: 'checkout/setAjax',
        }),
        changeData(name, value) {
            this.setRequestData({ name, value });
            this.setAjax();
        },
        changeCity(city) {
            this.currentCity = city;

            /** clean active shop **/
            if (this.getActiveDelivery?.storeInputName) {
                this.setRequestData([
                    { name: this.getActiveDelivery.storeInputName },
                    { name: this.inputStoreID },
                ]);
            }
            /** clean active warehouse **/
            if (this.getWarehousesInputName) {
                this.setRequestData([
                    { name: this.getWarehousesInputName },
                ]);
            }

            this.setRequestData([
                { name: this.getCityKey, value: city.UF_NAME }
            ]);
            this.setAjax();
        },

    },
    mounted() {
        // init current city
        if (this.userCity) {
            this.setRequestData([
                { name: this.getCityKey, value: this.userCity.UF_NAME }
            ]);
        }
    }
}
</script>

<style lang="scss" scoped>
.checkout-delivery-ukraine{
    &__header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
    }
    &__footer{
        //padding-left: 34px;
        padding-bottom: 16px;
    }
    &__block{
        &_disabled{
            pointer-events: none;
            opacity: .5;
        }
    }
    &__price{
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        color: var(--color-dark-grey);
        text-align: end;
    }
    &__free{
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        text-align: end;
        color: var(--text-colour-secondary);
    }
    :deep(.def-radio-component){
        align-items: center;
        font-weight: 500;
        font-size: 16px;
    }
}
</style>